// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MJ2Dj","index":"styles_index__3ipq8"};